module.exports = __webpack_public_path__ + "img/31.a7ea388c.jpg";